import { render, staticRenderFns } from "./ImageViewRound.vue?vue&type=template&id=0f9975eb&scoped=true"
import script from "./ImageViewRound.vue?vue&type=script&lang=ts"
export * from "./ImageViewRound.vue?vue&type=script&lang=ts"
import style0 from "./ImageViewRound.vue?vue&type=style&index=0&id=0f9975eb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9975eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9975eb')) {
      api.createRecord('0f9975eb', component.options)
    } else {
      api.reload('0f9975eb', component.options)
    }
    module.hot.accept("./ImageViewRound.vue?vue&type=template&id=0f9975eb&scoped=true", function () {
      api.rerender('0f9975eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ImageViewRound.vue"
export default component.exports